import { render, staticRenderFns } from "./PurchaseInfoForm.vue?vue&type=template&id=0098af3b&"
import script from "./PurchaseInfoForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports